// extracted by mini-css-extract-plugin
module.exports = {"centeredPdf":"businessInvoices_centeredPdf__3gr7F"};